import React from 'react';
import { DefaultAuthState } from '../../../core-module/models/redux/DefaultAuthState';
import TableColumn from '../../../models/Table/TableColumn';
import { Row, Col } from 'antd';
import ReviewEndpoint from '../../../core-module/models/LoopBack/Models/ReviewEndpoint';
import TableWithModal from '../../Table/TableWithModal';
import moment from 'moment';
import { Rate } from 'antd';
import CrudForm from '../../CrudForms/CrudForm';
import ReviewForm from '../../CrudForms/ReviewForm';
import { useTypedSelector } from '../../../core-module/redux';

interface Props {
  auth: DefaultAuthState;
}

const loopBackEndpoint = new ReviewEndpoint();

const Reviews: React.FC = () => {
  React.useEffect(() => {
    document.title = 'Logistics | Maaltijdbeoordelingen';
  }, []);

  const driverId = useTypedSelector((state) => state.auth.user.driver!.id);

  const columns = [
    new TableColumn('Datum', 'updated', 'updated').setRender((rowData) => {
      return moment(rowData).format('DD MMM');
    }),
    new TableColumn('Maaltijd', 'camasys_dish_name', 'camasys_dish_name').get(),
    new TableColumn('Beoordeling', 'rating', 'rating').setRender((rowData) => {
      return (
        <span>
          <Rate value={rowData} disabled /> [{rowData} / 5]
        </span>
      );
    }),
    new TableColumn('Opmerking', 'remarks', 'remarks').setAdditional({ width: '40%' }).get(),
    new TableColumn('Acties', '', 'actions')
      .setAdditional({ width: '100px' })
      .setRender((rowData) => {
        if (!rowData.posted_to_camasys) {
          return (
            <CrudForm
              title='Maaltijdbeoordeling bewerken'
              showButtonText={false}
              crudForm={
                <ReviewForm
                  stateKey='reviews'
                  rowData={rowData}
                  type='edit'
                  loopBackEndpoint={loopBackEndpoint}
                />
              }
            />
          );
        }
        return undefined;
      })
      .get()
  ];

  const filter = {
    filter: {
      fields: [
        'id',
        'created',
        'driver_id',
        'rating',
        'remarks',
        'camasys_dish_name',
        'week',
        'camasys_dish_id',
        'posted_to_camasys'
      ],
      where: {
        and: [{ driver_id: driverId }]
      },
      order: 'created DESC'
    }
  };

  return (
    <Row>
      <Col xs={24}>
        <TableWithModal
          title='Maaltijdbeoordelingen'
          bordered={true}
          striped={true}
          searchFields={['camasys_dish_name']}
          endPoint='reviews'
          loopBackEndpoint={loopBackEndpoint}
          stateKey='reviews'
          columns={columns}
          filters={filter}
          component={
            <span>
              <CrudForm
                title='Maaltijdbeoordeling toevoegen'
                showButtonText={true}
                crudForm={
                  <ReviewForm
                    filters={filter}
                    stateKey='reviews'
                    type='new'
                    loopBackEndpoint={loopBackEndpoint}
                  />
                }
              />
              <br />
              <em style={{ color: '#aaa' }}>
                Merk op: Als de maaltijdbeoordelingen eenmaal verwerkt zijn kunnen ze niet meer
                worden aangepast.
              </em>
            </span>
          }
        />
      </Col>
    </Row>
  );
};

export default Reviews;
